import styled from 'styled-components';

interface RuleBuilderItemWrapperProps {
  isHighlight?: boolean;
}

const RuleBuilderItemWrapper = styled.div<RuleBuilderItemWrapperProps>`
  box-shadow: ${(props): string => props.theme.boxShadow.default};
  background-color: ${(props): string => props.theme.colors.pureWhite};
  outline: 0.2rem solid
    ${(props): string =>
      props.isHighlight ? props.theme.colors.lightOrange : 'transparent'};
`;

export { RuleBuilderItemWrapper };
